import { Card, Confirm, Header } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import { ROUTE_ALERT_APP_URL } from '../../../app/common/data/constants';
import { useState } from 'react';

export default function PermitContentActionPage() {
    const [openConfirm, setOpenConfirm] = useState(false);

    function handleCancelButton() {
        setOpenConfirm(false);
    }
    function handleOKButton() {
        setOpenConfirm(false);
        window.location.href = ROUTE_ALERT_APP_URL;
    }

    return (
        <>
        <Header as='h2'>WSF On-line Goods/Services</Header>
        <Confirm
            open={openConfirm}
            header='Leaving this app?'
            content='You are about to redirect to Ferry Alerts. Would you like to proceed?'
            cancelButton='Cancel'
            confirmButton="Yes"
            onCancel={handleCancelButton}
            onConfirm={handleOKButton}
        />
        <Card.Group itemsPerRow={3} stackable doubling>
            <Card 
                target='_blank'
                onClick={() => setOpenConfirm(true)}
                style={{background: '#007b5f', color: 'white'}}
            >
                <Card.Content>
                    <Card.Header 
                        style={{color: 'white'}}
                    >Sign Up Ferry Alerts</Card.Header>
                    <Card.Description 
                        style={{color: 'white'}}
                    >
                    Receive bulletins/alerts via Email or SMS.
                    </Card.Description>
                </Card.Content>
            </Card>
            <Card 
                as={NavLink} 
                to='/createPermit/carpool'
                style={{background: '#007b5f', color: 'white'}}
            >
                <Card.Content>
                    <Card.Header 
                        style={{color: 'white'}}
                    >Carpool Permit</Card.Header>
                    <Card.Description 
                        style={{color: 'white'}}
                    >
                    Buy a Carpool Permit.
                    </Card.Description>
                </Card.Content>
            </Card>
            <Card 
                as={NavLink} 
                to='/createPermit/vanpool'
                style={{background: '#007b5f', color: 'white'}}
            >
                <Card.Content>
                    <Card.Header 
                        style={{color: 'white'}}
                    >Vanpool Permit</Card.Header>
                    <Card.Description 
                        style={{color: 'white'}}
                    >
                    Buy a Vanpool Permit.
                    </Card.Description>
                </Card.Content>
            </Card>
        </Card.Group>
        </>
    )
}